import React from "react";
import isNaN from "../../helpers/number";
import { IObjectMap } from "../../interfaces/common";

const TRANSLATES = {
  brutto: "Brutto",
  consignment_items: "TNVED",
  invoice: "Inv.",
  cargo_quantity: "CL",
  warranty: "Warranty",
  triplets: "3",
  eights: "8",
  others: "Others",
} as IObjectMap;

interface Props {
  name: string;
  general: number;
  total: number;
  fractionDigits?: number;
  className?: string;
}

const Summary: React.FC<Props> = ({
  name,
  general,
  total,
  fractionDigits = 3,
  className = "summary",
}) => (
  <div className={className}>
    <p>{TRANSLATES[name] as Record<string, string>}</p>
    <p>{isNaN(general) ? 0 : general.toFixed(fractionDigits)}</p>
    <p>{isNaN(total) ? 0 : total.toFixed(fractionDigits)}</p>
  </div>
);

export default Summary;
